import UserCombobox from "components/directus/combobox/user";
import SelectType from "components/select/type";
import useTableFilters from "@/hooks/useTableFilters";
import { FilterActions } from "components/filter/actions";
import FilterWrapper from "components/filter/wrapper";
import FiltersList from "components/filter/list";

export default function MyTeamTaskFilters({
  filters,
  setFilters,
  setIsOpen,
  isOpen,
  defaultFilters,
  clearFilters,
}) {
  const {
    localFilters,
    applyFilters,
    clearLocalFilters,
    handleSetLocalFilters,
  } = useTableFilters({
    filters,
    setFilters,
    setIsOpen,
    clearFilters,
    initialFilters: {
      assignee: undefined,
      type: undefined,
      ...defaultFilters,
    },
  });

  return (
    <FiltersList>
      <UserCombobox
        label="Assignee"
        value={localFilters?.assignee?._eq}
        onChange={(selectedItem) => {
          handleSetLocalFilters({
            ...localFilters,
            assignee: selectedItem ? { _eq: selectedItem } : undefined,
          });
        }}
        searchPlaceholder="search & select assignee"
        clearable={true}
        dependenton={isOpen}
      />

      <FilterWrapper label="Type">
        <SelectType
          collection="tasks"
          placeholder="Select Type"
          value={localFilters?.type?._eq}
          onChange={(selectedItem) => {
            handleSetLocalFilters({
              type: selectedItem ? { _eq: selectedItem } : undefined,
            });
          }}
          clearable={true}
        />
      </FilterWrapper>

      <FilterActions
        applyFilters={applyFilters}
        clearLocalFilters={clearLocalFilters}
      />
    </FiltersList>
  );
}